import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { TextField, MenuItem, Checkbox, ListItemText } from '@mui/material';

const itemId = (item, key) => item && (item.id || item._id || key);

const MultiSelectInput = ({
    dispatch,
    isLoading,
    input,
    meta = {},
    label,
    required,
    options,
    style,
    disabled,
    compact,
    ...props
}) => {
    const inputProps = input || {};
    const { touched, error } = meta;
    const selected = Array.isArray(inputProps.value) ? inputProps.value : [];
    const list = (options && Array.isArray(options) ? options : []).filter(Boolean);

    const selectedNames = selected
        .map((id) => {
            const item = list.find((entry) => String(itemId(entry)) === String(id));
            return item ? (item.name || item.title) : id;
        })
        .filter(Boolean)
        .join(', ');

    return (
        <div className={`pc-field${compact ? ' pc-field--compact' : ''}`} style={style}>
            {label && (
                <label className="pc-field__label">
                    {label}
                    {required ? <i>*</i> : null}
                </label>
            )}
            <TextField
                {...inputProps}
                value={selected}
                error={!!(touched && error)}
                helperText={touched && error}
                {...props}
                select
                required={false}
                hiddenLabel
                size="small"
                variant="outlined"
                disabled={isLoading || disabled}
                fullWidth
                SelectProps={{
                    multiple: true,
                    displayEmpty: true,
                    renderValue: () => selectedNames || 'Не выбрано',
                }}
            >
                {list.length > 0
                    ? list.map((item, key) => {
                        const id = itemId(item, key);
                        return (
                            <MenuItem
                                disabled={item.disabled}
                                key={id}
                                value={id}
                                style={{ fontSize: 12.5, padding: '2px 8px' }}
                            >
                                <Checkbox
                                    size="small"
                                    checked={selected.some((entry) => String(entry) === String(id))}
                                    sx={{ p: '4px', mr: '4px' }}
                                />
                                <ListItemText
                                    primary={item.name || item.title || `Option ${key + 1}`}
                                    primaryTypographyProps={{ fontSize: 12.5 }}
                                />
                            </MenuItem>
                        );
                    })
                    : (
                        <MenuItem value="" disabled>
                            Нет доступных опций
                        </MenuItem>
                    )}
            </TextField>
        </div>
    );
};

const mapStateToProps = (state, props) =>{
  const { fetch } = state;
  return {
      isLoading: !!fetch.loading
  }
}

export default compose(
  connect(mapStateToProps),
)(MultiSelectInput);